import { useCallback, useState } from 'react';
import client from 'src/utils/api/client';
import { CHECKLIST_VERSION_BASE_QUERY } from 'src/graphql/checklist/query';

export default (jobId) => {
  const [loading, setLoading] = useState(false);
  const [checklists, setChecklists] = useState([]);
  const checklistCache = {};

  const requestChecklist = async (versionId) => {
    const result = await client.query({
      query: CHECKLIST_VERSION_BASE_QUERY,
      variables: { id: versionId },
      fetchPolicy: 'network-only'
    });

    const checklistVersion = result?.data?.checklistVersion;
    return checklistVersion ? { id: checklistVersion?.checklistId , currentVersion: checklistVersion } : null;
  };

  return {
    checklists,
    loading,
    getChecklists: useCallback(async (checklistVersionIds = [])=>{
      try {
        setLoading(true);
        await Promise.all(checklistVersionIds.map(async id => {
          if (!checklistCache[id]) {
            checklistCache[id] = await requestChecklist(id);
          }
        }));
        setChecklists(Object.values(checklistCache).filter(checklist => !!checklist));
      }catch (err){
        console.error(err);
      }finally {
        setLoading(false);
      }
    },[jobId]),
  };
}
